import { ReportDto } from '../../Items/ReportDto';
import * as actionType from '../action';

export interface ReportState {
    reports: ReportDto[];
  }
  
  const initialState: ReportState = {
    reports: [],
  };


  const ReportReducer = (
    state: ReportState = initialState,
    action: any
  ): ReportState => {
    switch (action.type) {
      case actionType.GET_REPORTS:
        return { ...state, reports: action.payload ?? [] };
  
      case actionType.ADD_REPORT:
        return { ...state, reports: [...state.reports, action.payload] };
  
      default:
        return state; // אין צורך לעשות {...state}, מספיק להחזיר state
    }
  };

export default ReportReducer;